import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'

import { State } from './state'

/**
 * Core actions for the records bulk responsible persons workflow.
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /** Opens the bulk responsible persons modal for the current selection */
    initiate: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: () => State.onInitiate(),
    }),
    /** Closes the bulk responsible persons modal without applying anything */
    cancel: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: () => State.INITIAL,
    }),
    /** Adds or removes employees being made responsible */
    toggleEmployees: store.actions.standalone({
      data: store.actions.Data.asIs<State.ToggleEmployees>(),
      reducer: ({ state, data: toggle }) =>
        State.onToggleEmployees(toggle, state),
    }),
    /** Stores the employee to make the primary */
    setPrimaryEmployee: store.actions.standalone({
      data: store.actions.Data.asIs<ents.extra.space.Employee.Id | undefined>(),
      reducer: ({ state, data: primaryEmployeeId }) =>
        State.onSetPrimaryEmployee(primaryEmployeeId, state),
    }),
    /**
     * Applies the edited responsible persons to every selected record
     */
    submit: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.NONE,
      reducers: {
        request: ({ state }) => State.onRequest(state),
        success: () => State.INITIAL,
        error: ({ state, data: { error } }) => State.onError(error, state),
        cancellation: ({ state }) => State.onCancellation(state),
      },
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
